// Fetch My Students
export const FETCH_MY_STUDENTS_REQUEST = "FETCH_MY_STUDENTS_REQUEST";
export const FETCH_MY_STUDENTS_SUCCESS = "FETCH_MY_STUDENTS_SUCCESS";
export const FETCH_MY_STUDENTS_FAILURE = "FETCH_MY_STUDENTS_FAILURE";
export const FETCH_MY_STUDENTS_RESET = "FETCH_MY_STUDENTS_RESET";

// Fetch Coach Application Hours
export const FETCH_COACH_APP_HOURS_REQUEST = "FETCH_COACH_APP_HOURS_REQUEST";
export const FETCH_COACH_APP_HOURS_SUCCESS = "FETCH_COACH_APP_HOURS_SUCCESS";
export const FETCH_COACH_APP_HOURS_FAILURE = "FETCH_COACH_APP_HOURS_FAILURE";
export const FETCH_COACH_APP_HOURS_RESET = "FETCH_COACH_APP_HOURS_RESET";

// Fetch Total Log Sessions of Students
export const FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_REQUEST = "FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_REQUEST";
export const FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_SUCCESS = "FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_SUCCESS";
export const FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_FAILURE = "FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_FAILURE";
export const FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_RESET = "FETCH_TOTAL_LOG_SESSIONS_OF_STUDENTS_RESET";